import React from 'react';
import GenericModal from '../GenericModal';
import RegiaoVendasDrillDownContent from './RegiaoVendasDrillDownContent';
import { RegiaoVendasDrillDownData } from '../../types/regiaoVendasDrillDown';
import { Box, Typography } from '@mui/material';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface RegiaoVendasDrillDownModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: RegiaoVendasDrillDownData | null;
  loading: boolean;
  error: string | null;
  selectedRegiao: { nome: string } | null;
  onRetry: () => void;
}

const RegiaoVendasDrillDownModal: React.FC<RegiaoVendasDrillDownModalProps> = ({
  isOpen, onClose, data, loading, error, selectedRegiao, onRetry
}) => {
  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title={`Detalhes de Vendas - Região: ${selectedRegiao?.nome || 'N/A'}`}
      loading={false}
      maxWidth="lg"
      fullWidth
    >
        {loading ? (
          <ProductDrillDownSkeleton />
        ) : error ? (
            <Box sx={{ padding: 3, textAlign: 'center' }}>
                <Typography color="error">{error}</Typography>
                <button onClick={onRetry}>Tentar Novamente</button>
            </Box>
        ) : (
            data && <RegiaoVendasDrillDownContent data={data} />
        )}
    </GenericModal>
  );
};

export default RegiaoVendasDrillDownModal; 